import { PropertyFlag as SrsPropertyFlag } from 'srs-middleware';
import { propertyHierarchy } from '../endpoints';

import { CustomPackWrapper } from './customPackWrapper';
import { CustomPackKnobs } from './customPackKnobs';
import { filterProperties } from 'utilities/srsUtils';
import { generateLimitDropdownOptionsFromList } from 'components/dropdowns/limitDropdown';

const flags = [SrsPropertyFlag.Categorical];

export const config = {
	key: 'CUSTOM_CIRCLE_PACK',
	label: 'Custom Circle Pack',
	icon: 'circle-pack',
	wrapper: CustomPackWrapper,
	endpoint: propertyHierarchy,
	Knobs: CustomPackKnobs,
	flags: flags,
	createDefaultOptions: filteredProperties => {
		return {
			options: {
				propertyList: [filteredProperties[0].name, null, null],
				parameters: {
					maxRoot: 50,
					maxChildren: 500,
				},
			},
		};
	},
	createDefaultConfiguration: _filteredProperties => {
		return {
			showAllLabels: false,
			//see limitSelector.jsx. In essence the "maxChildren" part must match one of the fields in the above 'parameters' obj
			// and the "_options" is hardcoded.
			maxChildren_options: generateLimitDropdownOptionsFromList([
				'1,000', '750', '500', '250', '100', '50', '20', '10'
			])
		};
	},
	isValid: selectedDefinitionName => {
		return filterProperties(selectedDefinitionName, flags).length >= 1;
	},
};
